export default {
  title: 'Country regions',

  titles: {
    create: 'Create region'
  },

  labels: {
    region: 'Region',
    country: 'Country',
    regionCode: 'Region code',
    regionName: 'Region name',
    countryCode: 'Country code',
    countryName: 'Country name',
    timeZone: 'Time zone'
  },

  rules: {
    length: {
      range: 'Length from {minLength} to {maxLength} characters',
      exact: 'Length {maxLength} characters'
    },

    pattern: {
      regionCode: 'Latin letters and digits',
      regionName: 'Cyrillic and Latin letters, digits, space, apostrophe and hyphen',
      countryCode: 'Uppercase Latin letters',
      countryName: 'Cyrillic and Latin letters, space, apostrophe and hyphen',
      timeZone: 'Format UTC+HH:MM or UTC-HH:MM'
    }
  },

  infos: {
    form: '<b>Region code</b> - within the country, for example 77 or CA.<br><b>Region name</b> - for example Moscow.<br><b>Country code</b> - two-letter code, for example RU.<br><b>Country name</b> - for example Russia.<br><b>Time zone</b> - offset from UTC, for example UTC+03:00.'
  },

  warnings: {
    form: 'The pair of <b>country code</b> and <b>region code</b> must be unique.'
  },

  snackbars: {
    created: 'Region successfully created.',
    updated: 'Region successfully updated.',
    removed: 'Region successfully removed.'
  }
}
